export enum LinkExpiryDuration {
  OneDay = '1d',
  ThreeDays = '3d',
  FiveDays = '5d',
  OneWeek = '7d'
}

/**
 * Default expiry duration for a new payment link — the API schema default, the backend's
 * fallback when none is supplied, and each modal's initial selection should all read this
 * one value instead of repeating the literal so they can't drift out of sync.
 */
export const DEFAULT_LINK_EXPIRY_DURATION: LinkExpiryDuration = LinkExpiryDuration.ThreeDays;

/**
 * Payment link status — lifecycle of a buyer payment link
 */
export enum PaymentLinkStatus {
  /** Link is active and can be resolved by the buyer */
  ACTIVE = 'ACTIVE',
  /** Link was superseded by a resend — a new link was issued */
  REVOKED = 'REVOKED',
  /** Link was deliberately deactivated by the lawyer — no new link issued */
  CANCELLED = 'CANCELLED',
  /** Payment was accepted by the bank — terminal success outcome */
  COMPLETED = 'COMPLETED',
  /** Payment was declined or failed at the bank — terminal failure outcome */
  REJECTED = 'REJECTED',
  /** Link lapsed past expiresAt before payment was received — terminal */
  EXPIRED = 'EXPIRED'
}
